// Global capture of Chrome's beforeinstallprompt event so any button can trigger install.
// Also exposes helpers for the "is this installable natively?" question.

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export function canInstallDirectly() {
  return deferredPrompt !== null;
}

export function onInstallAvailabilityChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function triggerInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  try {
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
    return { outcome: choice.outcome }; // "accepted" | "dismissed"
  } catch {
    return { outcome: "error" };
  }
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}
